import React from 'react';
import { WhatsAppCta } from './WhatsAppCta';
import { TrendingUp, CheckCircle2 } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-slate-900" data-id="element-42">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-43">
        <div className="absolute top-0 -left-4 w-72 h-72 bg-green-500 rounded-full mix-blend-multiply filter blur-xl animate-blob" data-id="element-44"></div>
        <div className="absolute top-0 -right-4 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-2000" data-id="element-45"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl animate-blob animation-delay-4000" data-id="element-46"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="text-center max-w-4xl mx-auto" data-id="element-48">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-800 border border-slate-700 text-green-400 text-sm font-semibold mb-8 animate-fade-in-up" data-id="element-49">
            <TrendingUp className="w-4 h-4" data-id="element-50" />
            <span data-id="element-51">UK's #1 Digital Growth Agency</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-52">
            Dominate Search Results & <br className="hidden md:block" data-id="element-53" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-600" data-id="element-54">
              Skyrocket Your Sales
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-55">
            We help UK businesses grow with data-driven SEO, PPC, and digital
            marketing strategies. Stop guessing and start growing with Smart
            Market Digital.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-56">
            <WhatsAppCta size="xl" text="Start Your Growth - Chat Now" data-id="element-57" />
            <span className="text-slate-400 text-sm sm:hidden" data-id="element-58">
              No forms, instant response
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-slate-400 text-sm font-medium" data-id="element-59">
            {['No Long Contracts', 'UK Based Team', 'Proven Results', '24/7 Support'].map(item => <div key={item} className="flex items-center gap-2" data-id="element-60">
                <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-61" />
                {item}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}